import { render, staticRenderFns } from "./carousel1.vue?vue&type=template&id=1bef651a&scoped=true&"
import script from "./carousel1.vue?vue&type=script&lang=js&"
export * from "./carousel1.vue?vue&type=script&lang=js&"
import style0 from "./carousel1.vue?vue&type=style&index=0&id=1bef651a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bef651a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCarousel,VCarouselItem,VRow,VSheet})
